export class InvalidDateString extends Error {}

export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm'
export const DATE_FORMAT = 'DD.MM.YYYY'

/**
 * Pokusi se vykouzlit korektni Date objekt z inputString
 * @param {String} inputString
 * @param {Boolean} time
 * @return {Date}
 */
export function dateObjectFromInput(inputString) {
    const moment = require('moment')
    if (inputString.match(/^([0-9]{10})$/)) {
        return new Date(moment(inputString, 'X').format('YYYY-MM-DDTHH:mm'))
    }
    throw new InvalidDateString(`Invalid input string ${inputString}`)
}

/**
 * Vraci aktualni UNIX timestamp.
 * @return {int} Current UNIX timestamp.
 */
export function currentTimestamp() {
    return Math.floor(Date.now() / 1000)
}

export default {
    InvalidDateString,
    dateObjectFromInput,
    currentTimestamp,
}
